import React from "react";

import { StyledButton } from "./styles/Btn";

const Btn = ({
  label,
  hovercolor = "white",
  hoverbgcolor = "orange",
  textcolor = "white",
  onClick,
  full,
  ...props
}) => {
  return (
    <StyledButton
      {...props}
      bg-color={props["bg-color"] || "blue"}
      variant="contained"
      hovercolor={hovercolor}
      hoverbgcolor={hoverbgcolor}
      textcolor={textcolor}
      onClick={onClick}
      full={full ? full.toString() : null}
    >
      {label}
    </StyledButton>
  );
};

export default Btn;
